// extracted by extract-css-chunks-webpack-plugin
module.exports = {"xs":"667.98","sm":"947.98","md":"1023.98","lg":"1229.98","group":"BZwaLOPI","groupTitle":"nuvWqOzE","items":"Sffd8RVZ","itemLogo":"EmdvD2OL","itemStatus":"mjl2kAt6"};